/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GroupWithSelectionDto } from './GroupWithSelectionDto';
import {
    GroupWithSelectionDtoFromJSON,
    GroupWithSelectionDtoFromJSONTyped,
    GroupWithSelectionDtoToJSON,
    GroupWithSelectionDtoToJSONTyped,
} from './GroupWithSelectionDto';
import type { CatalogDto } from './CatalogDto';
import {
    CatalogDtoFromJSON,
    CatalogDtoFromJSONTyped,
    CatalogDtoToJSON,
    CatalogDtoToJSONTyped,
} from './CatalogDto';
import type { ProfileDto } from './ProfileDto';
import {
    ProfileDtoFromJSON,
    ProfileDtoFromJSONTyped,
    ProfileDtoToJSON,
    ProfileDtoToJSONTyped,
} from './ProfileDto';

/**
 * 
 * @export
 * @interface CatalogComparisonResponse
 */
export interface CatalogComparisonResponse {
    /**
     * 
     * @type {CatalogDto}
     * @memberof CatalogComparisonResponse
     */
    baseCatalog?: CatalogDto;
    /**
     * 
     * @type {CatalogDto}
     * @memberof CatalogComparisonResponse
     */
    resolvedCatalog?: CatalogDto;
    /**
     * 
     * @type {ProfileDto}
     * @memberof CatalogComparisonResponse
     */
    sourceProfile?: ProfileDto;
    /**
     * 
     * @type {Array<GroupWithSelectionDto>}
     * @memberof CatalogComparisonResponse
     */
    functions?: Array<GroupWithSelectionDto>;
}

/**
 * Check if a given object implements the CatalogComparisonResponse interface.
 */
export function instanceOfCatalogComparisonResponse(value: object): value is CatalogComparisonResponse {
    return true;
}

export function CatalogComparisonResponseFromJSON(json: any): CatalogComparisonResponse {
    return CatalogComparisonResponseFromJSONTyped(json, false);
}

export function CatalogComparisonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CatalogComparisonResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'baseCatalog': json['baseCatalog'] == null ? undefined : CatalogDtoFromJSON(json['baseCatalog']),
        'resolvedCatalog': json['resolvedCatalog'] == null ? undefined : CatalogDtoFromJSON(json['resolvedCatalog']),
        'sourceProfile': json['sourceProfile'] == null ? undefined : ProfileDtoFromJSON(json['sourceProfile']),
        'functions': json['functions'] == null ? undefined : ((json['functions'] as Array<any>).map(GroupWithSelectionDtoFromJSON)),
    };
}

export function CatalogComparisonResponseToJSON(json: any): CatalogComparisonResponse {
    return CatalogComparisonResponseToJSONTyped(json, false);
}

export function CatalogComparisonResponseToJSONTyped(value?: CatalogComparisonResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'baseCatalog': CatalogDtoToJSON(value['baseCatalog']),
        'resolvedCatalog': CatalogDtoToJSON(value['resolvedCatalog']),
        'sourceProfile': ProfileDtoToJSON(value['sourceProfile']),
        'functions': value['functions'] == null ? undefined : ((value['functions'] as Array<any>).map(GroupWithSelectionDtoToJSON)),
    };
}

